export const tags = [
  "jnct-activity-settings",
  "jnct-activity-settings-v2",
  "jnct-activity-settings-shell",
  "jnct-activity-settings-defaults",
  "jnct-activity-settings-form",
  "jnct-activity-settings-date-and-time-form",
  "jnct-activity-settings-preset-form",
  "jnct-activity-settings-change-summary",
  "activity-locked-modal",
  "jnct-batch-update-modal",
  "jnct-presets-list-modal",
  "jnct-show-hide-columns-modal",
  "jnct-wizard-modal",
  "diagnostic-module",
  "lwm-policy-logic",
] as const;
